// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-image-upload .upload-demo[data-v-3bc66dbc] {\n  text-align: left;\n}\n.file-image-upload[data-v-3bc66dbc]  .el-upload-list.el-upload-list--text {\n  width: 500px;\n}\n.file-template[data-v-3bc66dbc] {\n  font-family: PingFangSC-Regular;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 400;\n}\n.file-template a[data-v-3bc66dbc] {\n  font-family: PingFangSC-Semibold;\n  font-size: 14px;\n  color: #1FA0E8;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
